export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "videoGif": {
    "title": "视频转 GIF",
    "subtitle": "在线将 MP4、WEBM、MOV 视频转换为动画 GIF。",
    "privacy": "100% 本地处理",
    "noUpload": "无需上传",
    "uploadTitle": "上传视频",
    "uploadDesc": "拖拽或点击选择文件。支持 MP4、WEBM、MOV，最大 500MB。",
    "selectFile": "选择视频",
    "timeRange": "时间范围",
    "start": "开始",
    "end": "结束",
    "play": "播放片段",
    "pause": "暂停",
    "settings": "输出设置",
    "fps": "帧率",
    "fpsDesc": "帧率越高越流畅，但文件更大",
    "width": "宽度",
    "widthDesc": "高度自动按比例缩放",
    "estimated": "预计",
    "frames": "帧",
    "originalSize": "原始尺寸",
    "loadingEngine": "正在加载视频处理引擎...",
    "loading": "正在加载引擎...",
    "generating": "正在生成...",
    "generate": "生成 GIF",
    "processing": "正在处理视频...",
    "result": "生成结果",
    "invalidFile": "请上传视频文件（MP4、WEBM、MOV）",
    "fileTooLarge": "文件过大，最大支持 500MB。",
    "loadError": "无法加载视频，格式可能不受支持。",
    "ffmpegError": "视频处理引擎加载失败，请刷新页面重试。",
    "invalidRange": "时间范围无效",
    "generateError": "生成 GIF 失败："
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 视频转 GIF 转换完全通过 ffmpeg.wasm 在您的浏览器中运行。您的视频文件在本地处理，绝不会上传到任何外部服务器。"
    },
    "guide": {
      "title": "如何使用视频转 GIF 工具",
      "description": "将任意视频片段转为动画 GIF，适用于社交媒体、聊天和网页用途 —— 无需上传。",
      "steps": [
        {
          "title": "上传视频",
          "description": "从设备中选择视频文件（支持 MP4、WebM、MOV、AVI）。视频直接加载到浏览器中进行本地处理。"
        },
        {
          "title": "裁剪并调整设置",
          "description": "使用时间轴精确选择 GIF 的起止时间点。调整帧率、分辨率和质量，以控制文件大小和流畅度。"
        },
        {
          "title": "生成并下载",
          "description": "点击「生成 GIF」按钮开始转换。ffmpeg.wasm 引擎在浏览器本地处理视频，随后您可以立即下载成品 GIF。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "使用 ffmpeg.wasm 进行纯客户端视频处理",
        "支持 MP4、WebM、MOV 和 AVI 输入格式",
        "通过时间轴精确裁剪起止时间",
        "可调节帧率、分辨率和 GIF 质量",
        "生成最终输出前可实时预览",
        "零服务器上传 — 视频保留在您的设备上"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "为什么第一次转换耗时较长？",
          "answer": "首次使用时，ffmpeg.wasm（FFmpeg 的 WebAssembly 版本）需要加载到浏览器中。这是一次性设置，约 5–15 MB。后续转换启动速度会快得多。"
        },
        {
          "question": "最大支持多长的视频？",
          "answer": "没有固定限制，但 GIF 最适合 1–10 秒的短视频。更长的视频会产生非常大的 GIF 文件。对于较长内容，建议使用视频压缩或裁剪功能。"
        },
        {
          "question": "可以把 GIF 转回视频吗？",
          "answer": "本工具专注于视频转 GIF。如需反向转换，可以使用我们的视频转换工具，或保留原始视频文件。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "图片压缩工具",
          "url": "/image/image-compressor",
          "description": "转换后优化 GIF 和图片的文件大小。"
        },
        {
          "name": "图片尺寸调整",
          "url": "/image/image-resizer",
          "description": "将 GIF 精确调整到社交平台所需尺寸。"
        },
        {
          "name": "表情包生成器",
          "url": "/image/meme-generator",
          "description": "为您的 GIF 和图片添加文字和特效。"
        }
      ]
    }
  }
};
